import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IArticle {
  readonly id: string;
  readonly type: MESSAGES.ARTICLE;
  readonly articleId: string;
  readonly url: string;
  readonly rm: boolean;
  readonly nodeId: string;
  readonly role?: string;
  readonly conversationId?: string;
}

export const createArticle = (data): IArticle => ({
  id: data.id || uuid(),
  type: MESSAGES.ARTICLE,
  articleId: data.articleId,
  url: data.url,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
});
